export const REPORT_TYPE = {
  CHAT: "chat",
  CONFESSION: "confession",
  CONFESSION_COMMENT: "confession_comment",
  TASK: "task",
  CHAT_MESSAGE: "chat_message",
  USER: "user",
};
